import React, { useEffect, useState } from "react";
import GenomesStyle from "./genomes.module.css";
import {
  GenomeInformColums,
  GennomeInform,
} from "../../../assets/lotus_genome_aa/lotusaa/genome_information";
import {
  Americaon2022_1,
  Americaon2022_1Colums,
} from "../../../assets/lotus_genome_aa/lotusaa/American_Lotus_2022/1_stat";
import {
  Americaon2022_2,
  Americaon2022_2Colums,
} from "../../../assets/lotus_genome_aa/lotusaa/American_Lotus_2022/2_stat";
import {
  Americaon2022_3,
  Americaon2022_3Colums,
} from "../../../assets/lotus_genome_aa/lotusaa/American_Lotus_2022/3_stat";
import Americaon2024_1 from "../../../assets/lotus_genome_aa/lotusaa/American_Lotus_2024/1_stat";
import Americaon2024_2 from "../../../assets/lotus_genome_aa/lotusaa/American_Lotus_2024/2_stat";
import Americaon2024_3 from "../../../assets/lotus_genome_aa/lotusaa/American_Lotus_2024/3_stat";
import Asian_1 from "../../../assets/lotus_genome_aa/lotusaa/Asian_Lotus/1_stat";
import Asian_2 from "../../../assets/lotus_genome_aa/lotusaa/Asian_Lotus/2_stat";
import Asian_3 from "../../../assets/lotus_genome_aa/lotusaa/Asian_Lotus/3_stat";
import TaiZi_1 from "../../../assets/lotus_genome_aa/lotusaa/Tai_Zi_lotus/1_stat";
import TaiZi_2 from "../../../assets/lotus_genome_aa/lotusaa/Tai_Zi_lotus/2_stat";
import TaiZi_3 from "../../../assets/lotus_genome_aa/lotusaa/Tai_Zi_lotus/3_stat";
import Zi_1 from "../../../assets/lotus_genome_aa/lotusaa/Zi_lotus/1_stat";
import Zi_2 from "../../../assets/lotus_genome_aa/lotusaa/Zi_lotus/2_stat";
import Zi_3 from "../../../assets/lotus_genome_aa/lotusaa/Zi_lotus/3_stat";
import styled from "styled-components";
import { Select, Table, Collapse } from "antd";

// 修改折叠面板样式
const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important; /* 确保折叠箭头垂直居中 */
    color: #333; /* 自定义字体颜色 */
    border: none !important;
  }

  .ant-collapse-header .ant-collapse-arrow {
    display: flex;
    align-items: center; /* 确保箭头上下居中 */
    margin-left: 10px; /* 为箭头和标题之间增加间距 */
  }

  .ant-collapse-header.ant-collapse-header-active {
    background-color: #d9f7be; /* 展开时的背景颜色 */
    color: #000; /* 展开时的字体颜色 */
  }
`;

// 使用 styled-components 定义样式
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;
function Genomes() {
  const [SelectVal, setDSelectVal] = useState("AmericanLotus2022");
  const [American_Lotus_2022_1, setAmerican_Lotus_2022_1] = useState([]);
  const [American_Lotus_2022_2, setAmerican_Lotus_2022_2] = useState([]);
  const [American_Lotus_2022_3, setAmerican_Lotus_2022_3] = useState([]);
  useEffect(() => {
    console.log(SelectVal);
    if (SelectVal === "AmericanLotus2022") {
      setAmerican_Lotus_2022_1(Americaon2022_1);
      setAmerican_Lotus_2022_2(Americaon2022_2);
      setAmerican_Lotus_2022_3(Americaon2022_3);
    }
    if (SelectVal === "AmericanLotus2024") {
      setAmerican_Lotus_2022_1(Americaon2024_1);
      setAmerican_Lotus_2022_2(Americaon2024_2);
      setAmerican_Lotus_2022_3(Americaon2024_3);
    }
    if (SelectVal === "TaiZiLotus") {
      setAmerican_Lotus_2022_1(TaiZi_1);
      setAmerican_Lotus_2022_2(TaiZi_2);
      setAmerican_Lotus_2022_3(TaiZi_3 );
    }
    if (SelectVal === "AsianLotus") {
      setAmerican_Lotus_2022_1(Asian_1);
      setAmerican_Lotus_2022_2(Asian_2);
      setAmerican_Lotus_2022_3(Asian_3);
    }
    if (SelectVal === "ZiLotus") {
      setAmerican_Lotus_2022_1(Zi_1);
      setAmerican_Lotus_2022_2(Zi_2);
      setAmerican_Lotus_2022_3(Zi_3);
    }
  }, [SelectVal]);

  const items = [
    {
      key: "2",
      label: (
        <p
          style={{
            fontSize: "15px",
            fontWeight: "bold",
            background: "#C6F5E0",
            width: "15%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "50px",
            borderRadius: "30px",
          }}
        >
          Assembly Statistics
        </p>
      ),
      children: (
        <div className={GenomesStyle.Assembly_statistics}>
          {/* <p className={GenomesStyle.AssTtile}>2、Assembly Statistics</p> */}
          <StyledTable
            style={{ width: 99 + "%", margin: "auto" }}
            // dataSource={tableAssemble}
            columns={Americaon2022_1Colums}
            dataSource={American_Lotus_2022_1}
            pagination={false}
            rowKey={"Contig_Num"}
            bordered={true}
          />
            <StyledTable
              bordered={true}
              style={{ width: 99 + "%", margin: "0.625rem auto" }}
              dataSource={American_Lotus_2022_2}
              columns={Americaon2022_2Colums}
              pagination={false}
              rowKey={"type"}
            />
          <StyledTable
            bordered={true}
            style={{ width: 99 + "%", margin: "0.625rem auto" }}
            dataSource={American_Lotus_2022_3}
            columns={Americaon2022_3Colums}
            pagination={false}
            rowKey={"Name"}
          />
        </div>
      ),
    },
   
  ];

  const onChange = (key) => {
    console.log(key);
  };

  return (
    <div className={GenomesStyle.Genomes_app}>
      <div className={GenomesStyle.Genomes_Header}>
        <p>Assembly and Annotation</p>
      </div>
      <div className={GenomesStyle.Genomes_details}>
        <p>Genome detail</p>
        <StyledTable
          bordered={true}
          style={{ width: "100%", margin: "10px 0" }}
          columns={GenomeInformColums}
          dataSource={GennomeInform}
          pagination={false}
        />
      </div>
      <div className={GenomesStyle.Genomes_GenomeSelect}>
        <div className={GenomesStyle.Genomes_Genome_form}>
          <p>Genome</p>
          <Select
            style={{ width: 200 }}
            defaultValue={SelectVal}
            options={[
              {
                key: "1",
                label: "AmericanLotus2022",
                value: "AmericanLotus2022",
              },
              {
                key: "2",
                label: "NLU",
                value: "AmericanLotus2024",
              },
              
              { key: "3", label: "NNU", value: "AsianLotus" },
            ]}
            onChange={(e) => {
              setDSelectVal(e);
            }}
          />
        </div>
        <StyledCollapse
          items={items}
          defaultActiveKey={["2"]}
          onChange={onChange}
          style={{ width: "100%", margin: "10px 0", border: "none" }}
        />
      </div>
    </div>
  );
}

export default Genomes;
